import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import type { GuardedFeature } from '@core/feature-guard-legacy';
import { FeatureGuardMode, FeatureGuardDropdownItemComponent } from '@core/feature-guard-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  BadgeComponent,
  HeadingComponent,
  IconComponent,
  DropdownItemComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-redactor-inserts-dropdown-item',
  templateUrl: 'redactor-inserts-dropdown-item.component.html',
  styleUrls: ['./redactor-inserts-dropdown-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FeatureGuardDropdownItemComponent,
    DropdownItemComponent,
    IconComponent,
    HeadingComponent,
    BadgeComponent,
  ],
})
export class RedactorInsertsDropdownItemComponent {
  @Input() public iconName: IconName;
  @Input() public heading: string;
  @Input() public subheading: string;
  @Input() public selected: boolean;
  @Input() public featureGuard: GuardedFeature;
  @Input() public badgeText?: string;

  public stepInside = output<MouseEvent>();

  public featureGuardMode: typeof FeatureGuardMode = FeatureGuardMode;
}
